import React from "react";

export function TileContainer({
  children,
  x,
  y = 0,
  label,
}: {
  children: React.ReactNode;
  x: number;
  y?: number;
  label?: string;
}) {
  return (
    <pixiContainer x={x} y={y} label={label} cullable={true} cullableChildren={true}
    >
      {children}
    </pixiContainer>
  );
}
